import TabList from './_TabList.js'

export default (tabListId, tabListMarkerId, tabListCurrentId) => {
  const tabListElement = document.getElementById(tabListId)
  if (!tabListElement) {
    return
  }


  let gliders = [];
  let isMobileLandscape = false
  let isMobilePortrait = false
  if( window.innerWidth < 992 && window.innerWidth >= 576 ) {
    isMobileLandscape = true
  }
  else if( window.innerWidth < 576 ) {
    isMobilePortrait = true;
  }

  const tabListCurrent = document.getElementById(tabListCurrentId)
  const tabList = new TabList(tabListElement)
  const tabListMarker = document.getElementById(tabListMarkerId)
  tabList.tabs.forEach((tab, index) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault()
      event.currentTarget.tabList.selectTab(event.currentTarget)
      if (tabListMarker) {
        tabListMarker.dataset.selectedTabIndex = index
      }

      if( isMobilePortrait && tabListCurrent ) {
        tabListCurrent.innerText = event.currentTarget.innerText
        tabListElement.classList.remove('visible')
      }

      if( isMobileLandscape || isMobilePortrait ) {
        if( gliders[index] ) {
          gliders[index].updateControls()
          gliders[index].refresh()
        }
      }
    })
  })


  if( isMobilePortrait ) {
    tabListCurrent.addEventListener('click', (event) => {
      tabListElement.classList.toggle('visible')
    })
  }


  if( isMobileLandscape || isMobilePortrait ) {

    document.addEventListener('glider-loaded', hideFFScrollBars);
    document.addEventListener('glider-refresh', hideFFScrollBars);
    function hideFFScrollBars(e){
      var scrollbarHeight = 17; // Currently 17, may change with updates
      //if(/firefox/i.test(navigator.userAgent)){
        e.target.parentNode.style.height = (e.target.offsetHeight - scrollbarHeight) + 'px'
      //}
    }

    document.querySelectorAll('.content-gallery .glider').forEach((item, index) => {

      const indexBtn = item.getAttribute('aria-labelledby')

      gliders.push(
        new Glider(item, {
          slidesToShow: 1,
          slidesToScroll: 1,
          scrollLock: true,
          draggable: true,
          arrows: {
            //prev: '.glider-prev',
            //next: '.glider-next',
            prev: '.glider-prev--' + indexBtn,
            next: '.glider-next--' + indexBtn
          },
          responsive: [
            {
              // screens greater than >= 320px
              breakpoint: 320,
              settings: {
                // Set to `auto` and provide item width to adjust to viewport
                slidesToShow: 1,
                slidesToScroll: 1,
                duration: 0.25
              }
            },{
              // screens greater than >= 576px
              breakpoint: 576,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                duration: 0.25
              }
            }
          ]
        })
      )
    })

  }
  else {
    gliders.forEach(element => {
      element.destroy()
    });
    gliders = []
  }

}

